import React, {ReactElement, useEffect, useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  makeStyles,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import {Trans, useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import HelperUtils, {
  sanitizeEmrAlphanumericInput
} from '@shared/utils/HelperUtils';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import ButtonField from '@components/system/ButtonField/ButtonField';
import {
  APP_PRIMARY_COLOR,
  DEFAULT_GREY_COLOR,
  DEFAULT_WHITE_COLOR
} from 'src/style/variable';
import {Permission} from '@shared/services/PermissionService';
import {
  AppPermissions,
  BALANCE_TYPE_KEYS,
  PaymentTypes
} from '@shared/constants/Mapping';
import {useDispatch, useSelector} from 'react-redux';
import CardPayDialog from '@components/system/CardPayDialog/CardPayDialog';
import {
  cancelPatientCoPays,
  getGuarantor,
  getListOfPatientCoPays,
  getSpecificPatientDetails,
  markPatientPostedToEmr,
  markPatientUpdatedInEmr
} from '@shared/services/PatientsServices';
import {formatApiMessage} from '@shared/utils/formatApiMessage';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import Loader from '@components/framework/loader/Loader';
import ProfileBulkIcon from '@components/system/MyIcons/ProfileBulkIcon';
import SmsIcon from '@components/system/MyIcons/SmsIcon';
import CallIcon from '@components/system/MyIcons/CallIcon';
import LocationIcon from '@components/system/MyIcons/LocationIcon';
import './PatientDetailsCard.scss';
import MoneyReceive from '@components/system/MyIcons/MoneyRecieve';
import AdhocPaymentDashboard from '../../../Common/AdhocPaymentDashboard';
import CopayCancelAlert from '../../../Common/CopayCancelAlert';
import TertiaryButton from '@components/system/ButtonField/TertiaryButton';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';
import MinGridTable, {
  ColumnDef
} from '@components/system/MinGridTable/MinGridTable';
import {CommunicationService} from 'src/service/CommunicationService';
import MakeSettleStatement from '../../../Invoices/DueInvoices/MakeSettleStatement';
import {
  shouldShowPatientEmrSyncActions,
  canMarkPatientPostedInEmr,
  canMarkPatientUpdatedInEmr,
  isPatientAwaitingEmrPost,
  showsPatientEmrSyncedChip,
  showsPatientPostedEmrDetails,
  showsPatientUpdatedEmrDetails
} from '../../../EmrSync/utils/patientEmrSyncStatus';
import EmrSyncStatusChip from '../../../EmrSync/components/EmrSyncStatusChip';

const markUpdatedInEmrDialogPrimaryButtonStyle: React.CSSProperties = {
  width: 'auto',
  minWidth: '14rem',
  paddingLeft: '1.5rem',
  paddingRight: '1.5rem'
};

const patientDetailsCard = makeStyles(() => ({
  copayBalance: {
    fontSize: '1rem',
    lineHeight: '1rem',
    paddingLeft: '0.5rem'
  },
  addCopayButton: {
    backgroundColor: APP_PRIMARY_COLOR,
    color: DEFAULT_WHITE_COLOR,
    height: '2rem',
    borderColor: APP_PRIMARY_COLOR,
    borderWidth: APP_PRIMARY_COLOR,
    fontSize: '1rem',
    lineHeight: '1rem',
    '&:hover': {
      backgroundColor: APP_PRIMARY_COLOR
    }
  },

  loaderStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  cardHeader: {
    '& .MuiCardContent-root': {
      padding: '0'
    }
  },
  commonStyle: {
    fontFamily: 'RobotoRegular, Arial',
    fontWeight: 400,
    fontSize: '1.1rem',
    color: '#343434',
    lineHeight: '23px'
  },
  copayParent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '0.5rem'
  },
  editButton: {
    borderRadius: '4px',
    height: '2rem',
    padding: '5px 15px'
  },
  pay: {
    background: 'rgba(40, 132, 255, 0.1)',
    borderRadius: '8px',
    padding: '0.5rem',
    paddingInline: '0.75rem',
    color: APP_PRIMARY_COLOR,
    overflowWrap: 'break-word',
    cursor: 'pointer',
    marginTop: '1rem'
  },
  DetailName: {
    fontSize: '1rem',
    color: '#54585b',
    maxWidth: '20rem',
    overflowWrap: 'break-word'
  },
  copaySection: {
    flexDirection: 'column',
    display: 'flex'
  },
  copayAuditInfo: {
    color: DEFAULT_GREY_COLOR,
    fontSize: '0.8rem'
  },
  emrStatusLink: {
    textAlign: 'right',
    whiteSpace: 'nowrap'
  },
  headerActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '0.25rem'
  }
}));
interface PatientDetailsCardProps {
  patientId: number;
  clinicId: number;
  patient: any;
  emrSyncRefreshKey?: number;
}
const PatientDetailsCard = (props: PatientDetailsCardProps): ReactElement => {
  const classes = patientDetailsCard();
  const {patientId, clinicId, patient, emrSyncRefreshKey = 0} = props;
  const {t} = useTranslation();
  const [cardPopUpOpen, setCardPopUpOpen] = useState<boolean>(false);
  const groupId: any = useSelector((state: any) => state.auth.groupId || null);
  const [forceUpdate, setForceUpdate] = useState(0);
  // FIXME: ADD PROPER TYPES
  const patientShared = useSelector(
    (state: any) => state.clinics.patientShared
  );
  const dispatch = useDispatch();
  const userPermissions: any = useSelector(
    (state: any) => state.auth.userPermissions || {}
  );
  const acOfClinics: any = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const [guarantorInfo, setGuarantorInfo]: any = useState({});
  const [patientDetail, setPatientDetail]: any = useState({});
  const {enqueueSnackbar} = useSnackbar();
  const [isLoadingPatientDetails, setIsLoadingPatientDetails] = useState(true);
  const [isPostingToEmr, setIsPostingToEmr] = useState(false);
  const [isMarkingUpdatedInEmr, setIsMarkingUpdatedInEmr] = useState(false);
  const [postToEmrDialog, setPostToEmrDialog] = useState({
    open: false,
    accountNumber: ''
  });
  const [markUpdatedInEmrDialogOpen, setMarkUpdatedInEmrDialogOpen] = useState(
    false
  );
  // ** Copay functionality decalartions --> START ** //
  const [state, setState] = useState<{
    selectedPatientCopayInvoiceLine: any;
    openSettleCopayDialog: boolean;
  }>({
    selectedPatientCopayInvoiceLine: {},
    openSettleCopayDialog: false
  });
  const {selectedPatientCopayInvoiceLine, openSettleCopayDialog} = state;
  // Function to update the copay functionality state values
  const updateState = (updates: Partial<typeof state>) => {
    setState(prevState => ({
      ...prevState,
      ...updates
    }));
  };
  // ** Copay functionality decalartions --> END ** //

  const hasEditPatientPermission = Permission.hasPatientPermissions(
    userPermissions,
    AppPermissions.PATIENT.EDIT,
    groupId
  );
  const showEmrSyncActions = shouldShowPatientEmrSyncActions(patientDetail);

  const renderDetailRow = (
    label: string,
    value: React.ReactNode,
    options?: {
      icon?: React.ReactNode;
      testId?: string;
    }
  ): ReactElement => (
    <div className="icon-wrapper">
      <div className="icon-child-wrapper">
        <div
          className={[
            'icon-style',
            options?.icon ? '' : 'icon-style--spacer'
          ].join(' ')}>
          {options?.icon}
        </div>
        <div className="detail-row-label">{label}</div>
      </div>
      <Typography className={[classes.DetailName, 'detail-colon'].join(' ')}>
        :
      </Typography>
      <div className="icon-child-wrapper" data-test-id={options?.testId}>
        {value}
      </div>
    </div>
  );

  const renderPostedByName = (): string => {
    const postedBy = patientDetail?.posted_by?.trim();
    return (
      postedBy ||
      (patientDetail?.posted_to_emr
        ? 'Inbound EMR Sync'
        : t('COMMON.NONE_VALUE'))
    );
  };

  const renderPostedOnDate = (): string => {
    if (!patientDetail?.posted_at) {
      return t('COMMON.NONE_VALUE');
    }

    return HelperUtils.formatDisplayDateTime(patientDetail.posted_at);
  };

  const renderUpdatedInEmrByName = (): string => {
    const updatedBy = patientDetail?.updated_in_emr_by?.trim();
    return updatedBy || t('COMMON.NONE_VALUE');
  };

  const renderUpdatedInEmrOnDate = (): string => {
    if (!patientDetail?.updated_in_emr_at) {
      return t('COMMON.NONE_VALUE');
    }

    return HelperUtils.formatDisplayDateTime(patientDetail.updated_in_emr_at);
  };

  const emrActionLinkStyle = {
    cursor: isPostingToEmr || isMarkingUpdatedInEmr ? 'wait' : 'pointer',
    opacity: isPostingToEmr || isMarkingUpdatedInEmr ? 0.6 : 1
  };

  const renderEmrPatientStatus = (): React.ReactNode => {
    const canPost = canMarkPatientPostedInEmr(patientDetail);
    const canUpdate = canMarkPatientUpdatedInEmr(patientDetail);

    if (canPost) {
      if (!hasEditPatientPermission) {
        return t('PATIENTS.EMR_STATUS_NOT_POSTED');
      }

      return (
        <Link
          component="button"
          className={`link-style ${classes.emrStatusLink}`}
          variant="body2"
          disabled={isPostingToEmr}
          onClick={openPostToEmrDialog}
          style={emrActionLinkStyle}>
          {t('PATIENTS.MARK_POSTED_IN_EMR')}
        </Link>
      );
    }

    if (!patientDetail?.posted_to_emr) {
      return t('PATIENTS.EMR_STATUS_NOT_POSTED');
    }

    if (canUpdate) {
      if (!hasEditPatientPermission) {
        return t('PATIENTS.EMR_STATUS_NOT_UPDATED');
      }

      return (
        <Link
          component="button"
          className={`link-style ${classes.emrStatusLink}`}
          variant="body2"
          disabled={isMarkingUpdatedInEmr}
          onClick={openMarkUpdatedInEmrDialog}
          style={emrActionLinkStyle}>
          {t('PATIENTS.UPDATE_IN_EMR')}
        </Link>
      );
    }

    if (showsPatientEmrSyncedChip(patientDetail)) {
      return <EmrSyncStatusChip hasIntegration syncStatus="synced" />;
    }

    return t('PATIENTS.NOT_AVAILABLE');
  };

  const renderEmrStatusInDetails = (): React.ReactNode => {
    if (showsPatientEmrSyncedChip(patientDetail)) {
      return <EmrSyncStatusChip hasIntegration syncStatus="synced" />;
    }

    return t('PATIENTS.NOT_AVAILABLE');
  };

  const showPatientEmrActionInHeader =
    showEmrSyncActions &&
    (canMarkPatientPostedInEmr(patientDetail) ||
      canMarkPatientUpdatedInEmr(patientDetail));

  const showEmrStatusInDetails =
    showEmrSyncActions && showsPatientEmrSyncedChip(patientDetail);

  const openPostToEmrDialog = (): void => {
    if (
      !canMarkPatientPostedInEmr(patientDetail) ||
      isPostingToEmr ||
      !patientDetail?.patient_id
    ) {
      return;
    }

    setPostToEmrDialog({
      open: true,
      accountNumber: patientDetail?.patient_account_number || ''
    });
  };

  const closePostToEmrDialog = (): void => {
    setPostToEmrDialog({
      open: false,
      accountNumber: ''
    });
  };

  const openMarkUpdatedInEmrDialog = (): void => {
    if (
      !canMarkPatientUpdatedInEmr(patientDetail) ||
      isMarkingUpdatedInEmr ||
      !patientDetail?.patient_id
    ) {
      return;
    }

    setMarkUpdatedInEmrDialogOpen(true);
  };

  const closeMarkUpdatedInEmrDialog = (): void => {
    setMarkUpdatedInEmrDialogOpen(false);
  };

  const handleMarkPatientUpdatedInEmr = async (): Promise<void> => {
    if (
      !canMarkPatientUpdatedInEmr(patientDetail) ||
      isMarkingUpdatedInEmr ||
      !patientDetail?.patient_id
    ) {
      return;
    }

    try {
      setIsMarkingUpdatedInEmr(true);
      const response = await markPatientUpdatedInEmr(
        groupId,
        patientDetail.patient_id
      );
      if (response) {
        enqueueSnackbar(
          response.message || t('PATIENTS.UPDATED_IN_EMR_STATUS_SAVED'),
          SnackBarConfig('s')
        );
        setPatientDetail((prev: any) => ({
          ...prev,
          updated_in_emr: true,
          updated_in_emr_at: new Date().toISOString()
        }));
        closeMarkUpdatedInEmrDialog();
        setForceUpdate(prev => prev + 1);
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsMarkingUpdatedInEmr(false);
    }
  };

  const handleMarkPatientPostedToEmr = async (): Promise<void> => {
    const enteredAccountNumber = postToEmrDialog.accountNumber.trim();

    if (
      !canMarkPatientPostedInEmr(patientDetail) ||
      isPostingToEmr ||
      !patientDetail?.patient_id
    ) {
      return;
    }

    try {
      setIsPostingToEmr(true);
      const response = await markPatientPostedToEmr(
        groupId,
        patientDetail.patient_id,
        {account_number: enteredAccountNumber || undefined}
      );
      if (response) {
        enqueueSnackbar(
          response.message || t('PATIENTS.POSTING_STATUS_UPDATED'),
          SnackBarConfig('s')
        );
        setPatientDetail((prev: any) => ({
          ...prev,
          posted_to_emr: true,
          posted_at: new Date().toISOString(),
          ...(enteredAccountNumber
            ? {patient_account_number: enteredAccountNumber}
            : {})
        }));
        closePostToEmrDialog();
        setForceUpdate(prev => prev + 1);
      }
    } catch (error: any) {
      enqueueSnackbar(formatApiMessage(error), SnackBarConfig('e'));
    } finally {
      setIsPostingToEmr(false);
    }
  };

  const renderFullAddress = (detailsObject: any) => {
    if (!detailsObject) {
      return '';
    } else {
      return HelperUtils.formatFullAddress({
        line1: detailsObject.patient_add_1,
        line2: detailsObject.patient_add_2,
        city: detailsObject.patient_city,
        state: detailsObject.patient_state,
        country: detailsObject.patient_country,
        zip: detailsObject.patient_zip_code
      });
    }
  };

  const openPayPopOver = (data: any) => {
    // FETCHING OF ALL GUARANTOR DETAILS.
    getGuarantor(groupId, data?.guarantor_id, acOfClinics[0] ?? clinicId)
      .then(async res => {
        if (res && res?.data) {
          // GUARANTOR DETAILS.....
          setGuarantorInfo(res?.data?.guarantor || {});
          // STORING PAYMENT TYPE TO REDUX
          dispatch({
            type: 'PAYMENT_TYPE',
            payload: {
              data: PaymentTypes.TOTAL_PAYMENT
            }
          });
          // OPEN PAYMENT DIALOG
          setCardPopUpOpen(true);
        }
      })
      .catch((err: any) => {
        enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      });
  };

  const closePayPopOver = () => {
    setCardPopUpOpen(false);
    // props._guarantorPayAmount(0);
  };

  const fetchPatientDetails = async () => {
    if (patientId) {
      getSpecificPatientDetails(groupId, acOfClinics[0] ?? clinicId, patientId)
        .then(async res => {
          if (res && res?.data) {
            setPatientDetail(res?.data);
          }
          // setForceUpdate(forceUpdate + 1);
        })
        .catch(err => {
          enqueueSnackbar(
            (err && err.message) || t('PATIENTS.GET_PATIENT_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
        })
        .finally(() => {
          setIsLoadingPatientDetails(false);
        });
    }
  };
  const [copayPopOver, setCopayPopOver] = useState<boolean>(false);

  const handleCopay = () => {
    setCopayPopOver(!copayPopOver);
  };

  const [patientCopayObject, setPatientCopayObject] = useState({
    cancel: false,
    copayList: [],
    update: false,
    copayCancelList: [],
    copayUpdateList: []
  });

  const handleCopayCancelClose = () => {
    setPatientCopayObject(prevPatientCopayObject => ({
      ...prevPatientCopayObject,
      cancel: false,
      copayCancelList: []
    }));
  };

  const handleCancelCopay = async (): Promise<void> => {
    setPatientCopayObject(prevPatientCopayObject => ({
      ...prevPatientCopayObject,
      cancel: true
    }));
  };

  const handleSelectCopay = (item: any) => {
    const selectedList: any = patientCopayObject.copayCancelList;
    const index = HelperUtils.getIndexOfElement(selectedList, item?.id);

    if (index === -1) {
      selectedList.push(item?.id);
    } else {
      selectedList.splice(index, 1);
    }
    // setting Up selected cancel item to state
    setPatientCopayObject(prevPatientCopayObject => ({
      ...prevPatientCopayObject,
      copayCancelList: selectedList
    }));
  };

  // PatientDetailsCard functionalities and Actions
  const cancelSelectedCopay = async (): Promise<void> => {
    try {
      const selectedList: any = patientCopayObject.copayCancelList;
      const payload = {
        delete_ids: selectedList
      };
      const response = await cancelPatientCoPays(
        groupId,
        clinicId ?? acOfClinics[0],
        payload
      );
      if (response) {
        enqueueSnackbar(response && response.message, SnackBarConfig('s'));
        handleCopayCancelClose();
        setForceUpdate(forceUpdate + 1);
        // Trigger an event when patient copay is removed
        CommunicationService.sendEvent({
          action: 'PATIENT_COPAY_REMOVED',
          data: null
        });
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
    }
  };

  React.useEffect(() => {
    fetchPatientDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceUpdate, emrSyncRefreshKey]);

  const [isLoadingCopayBalances, setIsLoadingCopayBalances] = useState(true);

  useEffect(() => {
    const fetchPatientCoPays = async () => {
      try {
        setIsLoadingCopayBalances(true);
        const copayList = await getListOfPatientCoPays(
          groupId,
          clinicId ?? acOfClinics[0],
          patientId
        );
        if (Array.isArray(copayList?.data?.rows)) {
          setPatientCopayObject(prevPatientCopayObject => ({
            ...prevPatientCopayObject,
            copayList: copayList?.data?.rows
          }));
        }
      } catch (err: any) {
        enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      } finally {
        setIsLoadingCopayBalances(false);
      }
    };
    if (
      Permission.hasPaymentHistoryPermissions(
        userPermissions,
        AppPermissions.PATIENT.LIST,
        groupId
      )
    ) {
      fetchPatientCoPays();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceUpdate]);

  // TODO: ASK
  const totalCopayBalanceAmount = patientCopayObject.copayList.reduce(
    (amount, item) => {
      return (
        amount +
        Number(item?.['charge_amount'] ?? 0) -
        Number(item?.['paid_amount'] ?? 0)
      );
    },
    0
  );

  const renderCardPopUp = (): ReactElement => {
    return (
      <CardPayDialog
        guarantorId={guarantorInfo.id}
        clinicId={clinicId ?? acOfClinics[0]}
        clinicGroupId={groupId}
        guarantorName={HelperUtils.commaSeparatedFullName(
          guarantorInfo.first_name,
          guarantorInfo.last_name,
          guarantorInfo.middle_name
        )}
        guarantorDetails={{
          id: guarantorInfo.id,
          first_name: guarantorInfo.first_name,
          last_name: guarantorInfo.last_name,
          middle_name: guarantorInfo.middle_name,
          clinic_group_id: guarantorInfo.clinic_group_id,
          clinic_id: guarantorInfo.clinic_id,
          email: guarantorInfo.email,
          address_line_1: guarantorInfo.address_line_1,
          zip_code: guarantorInfo.zip_code
        }}
        open={cardPopUpOpen}
        handleClose={reason => {
          if (reason === 'success') {
            if (typeof fetchPatientDetails == 'function') {
              fetchPatientDetails();
            }
          }
          closePayPopOver();
          setForceUpdate(f => f + 1);
        }}
      />
    );
  };
  // ** Settle the copay functionality ---> START ** //
  const renderConfirmationForSettleTheCopay = () => {
    if (openSettleCopayDialog && selectedPatientCopayInvoiceLine) {
      return (
        <MakeSettleStatement
          title={
            <Trans
              i18nKey={'DUE_INVOICES.SETTLE_COPAY.TITLE'}
              values={{
                name: selectedPatientCopayInvoiceLine.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          subTitle={
            <Trans
              i18nKey={'DUE_INVOICES.SETTLE_COPAY.SETTLE_TYPE_NOTE'}
              values={{
                notice_type: 'Settle this Copay',
                name: selectedPatientCopayInvoiceLine.name
              }}
              components={[<strong key={'X'} />]}
            />
          }
          data-test-id="pcl-payments-copaysettlementPopUp"
          open={openSettleCopayDialog}
          onClose={res => {
            // Reset the state values
            updateState({
              openSettleCopayDialog: false,
              selectedPatientCopayInvoiceLine: {}
            });
            if (res === 'submit') {
              if (typeof fetchPatientDetails == 'function') {
                fetchPatientDetails();
              }
            }
            setForceUpdate(f => f + 1);
          }}
          clinicId={selectedPatientCopayInvoiceLine?.clinic_id}
          groupId={groupId}
          guarantorId={selectedPatientCopayInvoiceLine.id}
          selectedCopayId={selectedPatientCopayInvoiceLine.copay_id}
          isSettleCopay={true}
        />
      );
    }
  };
  const handlePopOverItemClick = (item: {
    clinicId: number;
    firstName: string;
    lastName: string;
    middleName: string;
    copayId: number;
  }) => {
    updateState({
      selectedPatientCopayInvoiceLine: {
        ...state.selectedPatientCopayInvoiceLine,
        clinic_id: item.clinicId,
        name: HelperUtils.commaSeparatedFullName(
          item?.firstName,
          item?.lastName,
          item?.middleName
        ),
        copay_id: item?.copayId
      },
      openSettleCopayDialog: true
    });
  };

  // ** Settle the copay functionality end ** //

  const copayColDefs: ColumnDef<any>[] = [
    {
      label: t('PATIENT_DETAILS_CARD.LOCATION'),
      render(obj) {
        return (
          <div className={classes.copaySection}>
            <span>{obj?.clinic_detail?.name || '-'}</span>
            <span className={classes.copayAuditInfo}>
              {t('COMMON.ADDED_BY', {
                name: HelperUtils.commaSeparatedFullName(
                  obj?.user?.first_name,
                  obj?.user?.last_name
                )
              })}
            </span>
            <span className={classes.copayAuditInfo}>
              {t('COMMON.AT', {
                date: HelperUtils.formatDisplayDate(
                  obj?.created_at,
                  'MM/DD/YYYY'
                )
              })}
            </span>
          </div>
        );
      }
    },
    {
      label: t('PATIENT_DETAILS_CARD.DESCRIPTION'),
      render(obj) {
        return obj?.description || '';
      }
    },
    {
      label: t('PATIENT_DETAILS_CARD.ORIGINAL_BALANCE'),
      render(obj) {
        return (
          <CurrencyFormatter
            value={obj[BALANCE_TYPE_KEYS.COPAY_BALANCE_KEY] || '0'}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            ignoreRound={true}
            useSign={true}
          />
        );
      }
    },
    {
      label: t('PATIENT_DETAILS_CARD.HEADERS.PAID'),
      render(obj) {
        return (
          <p className="settle-view amount-col">
            <CurrencyFormatter
              value={obj[BALANCE_TYPE_KEYS.COPAY_BALANCE_PAID] || '0'}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </p>
        );
      }
    },
    {
      label: t(''),
      render(obj) {
        return (
          <div>
            {obj?.charge_type &&
              Permission.hasPatientPermissions(
                userPermissions,
                AppPermissions.PATIENT.SETTLE_COPAY,
                groupId
              ) && (
                <Link
                  data-test-id="pcl-payments-settleCopayHyperLink"
                  className={`link-style`}
                  key={'settle_this_copay'}
                  component="button"
                  onClick={() => {
                    handlePopOverItemClick({
                      clinicId: obj?.clinic_id,
                      firstName: patientDetail?.first_name,
                      middleName: patientDetail?.middle_name,
                      lastName: patientDetail?.last_name,
                      copayId: obj?.id
                    });
                  }}>
                  {t('DUE_INVOICES.UPDATE_NOTICE_TYPE.COPAY_SETTLE')}
                </Link>
              )}
          </div>
        );
      }
    }
  ];

  return (
    <div className="main-class">
      <Typography className="card-title">
        {t('PATIENTS.DRAWER.TITLE')}
      </Typography>
      {isLoadingPatientDetails && (
        <div className={classes.loaderStyle}>{<Loader />}</div>
      )}
      {!isLoadingPatientDetails && (
        <>
          <Card className={classes.cardHeader + ' ' + 'card-header'}>
            <CardContent>
              <div className="top-div">
                <div className="card-name-header">
                  <div className="profile-message-wrapper">
                    <div className="profile-icon">
                      {<ProfileBulkIcon className="user-avatar" />}
                    </div>
                    <div className="patient-name">
                      {HelperUtils.commaSeparatedFullName(
                        patientDetail.first_name,
                        patientDetail.last_name,
                        patientDetail.middle_name
                      )}
                    </div>
                  </div>
                  {showPatientEmrActionInHeader ? (
                    <div className={classes.headerActions}>
                      <Tooltip
                        title={
                          isPatientAwaitingEmrPost(patientDetail)
                            ? t('PATIENTS.MARK_POSTED_IN_EMR').toString()
                            : t('PATIENTS.UPDATE_IN_EMR').toString()
                        }
                        placement="top">
                        <span>{renderEmrPatientStatus()}</span>
                      </Tooltip>
                    </div>
                  ) : null}
                </div>
                <div className="card-name-child">
                  <div className="card-name-child-wrapper">
                    <div className="card-name-details">
                      {t('PATIENTS.DRAWER.FIRST_NAME')}
                    </div>
                    <div className="card-name-details">
                      {t('PATIENTS.DRAWER.MIDDLE_NAME')}
                    </div>
                    <div className="card-name-details">
                      {t('PATIENTS.DRAWER.LAST_NAME')}
                    </div>
                    <div className="card-name-details">
                      {t('PATIENT_DETAILS_CARD.ACCOUNT_NUMBER')}
                    </div>
                  </div>
                  <div className="card-name-child-wrapper-2">
                    <div
                      className="card-name-child-next "
                      data-test-id="pcl-patientRecall-patientFirstName">
                      {patientDetail.first_name || '-'}
                    </div>
                    <div
                      className="card-name-child-next"
                      data-test-id="pcl-patientRecall-patientMiddleName">
                      {patientDetail.middle_name || '-'}
                    </div>
                    <div
                      className="card-name-child-next"
                      data-test-id="pcl-patientRecall-patientLastName">
                      {patientDetail.last_name || '-'}
                    </div>
                    <div
                      className="card-name-child-next "
                      data-test-id="pcl-patientRecall-patientAccountNumber">
                      {patientDetail.patient_account_number || '-'}
                    </div>
                  </div>
                </div>
              </div>
              <div className="middle-div">
                {renderDetailRow(
                  t('PATIENT_DETAILS_CARD.EMAIL'),
                  patientDetail.email || t('PATIENTS.NOT_AVAILABLE'),
                  {
                    icon: <SmsIcon />,
                    testId: 'pcl-patientRecall-patientEmail'
                  }
                )}
                {renderDetailRow(
                  t('PATIENTS.DRAWER.PHONE'),
                  patientDetail.patient_phone ? (
                    <PhoneNumberFormatter value={patientDetail.patient_phone} />
                  ) : (
                    t('PATIENTS.NOT_AVAILABLE')
                  ),
                  {
                    icon: <CallIcon />,
                    testId: 'pcl-patientRecall-patientPhone'
                  }
                )}
                {renderDetailRow(
                  t('PATIENTS.DRAWER.ADDRESS'),
                  renderFullAddress(patientDetail) !== ''
                    ? renderFullAddress(patientDetail)
                    : t('PATIENTS.NOT_AVAILABLE'),
                  {
                    icon: <LocationIcon />,
                    testId: 'pcl-patientRecall-patientAddress'
                  }
                )}
                {showEmrSyncActions && (
                  <>
                    {showEmrStatusInDetails
                      ? renderDetailRow(
                          t('PATIENTS.EMR_POSTED_STATUS_LABEL'),
                          renderEmrStatusInDetails(),
                          {testId: 'pcl-patientRecall-patientEmrStatus'}
                        )
                      : null}
                    {showsPatientUpdatedEmrDetails(patientDetail) ? (
                      <>
                        {renderDetailRow(
                          t('PATIENTS.EMR_UPDATED_BY'),
                          renderUpdatedInEmrByName(),
                          {testId: 'pcl-patientRecall-patientEmrUpdatedBy'}
                        )}
                        {renderDetailRow(
                          t('PATIENTS.EMR_UPDATED_ON'),
                          renderUpdatedInEmrOnDate(),
                          {testId: 'pcl-patientRecall-patientEmrUpdatedOn'}
                        )}
                      </>
                    ) : null}
                    {showsPatientPostedEmrDetails(patientDetail) ? (
                      <>
                        {renderDetailRow(
                          t('PATIENTS.EMR_POSTED_BY'),
                          renderPostedByName(),
                          {testId: 'pcl-patientRecall-patientEmrPostedBy'}
                        )}
                        {renderDetailRow(
                          t('PATIENTS.EMR_POSTED_ON'),
                          renderPostedOnDate(),
                          {testId: 'pcl-patientRecall-patientEmrPostedOn'}
                        )}
                      </>
                    ) : null}
                  </>
                )}
                {/* Last visited on */}
                {/* <div className="icon-wrapper">
              <div className="icon-child-wrapper">{<ClockIcon />}</div>
              <div className="icon-child-wrapper">
                {`Last Visited On : ${
                  HelperUtils.formatDisplayDate(patientDetail?.visit_on) ??
                  t('PATIENTS.NOT_AVAILABLE')
                }`}
              </div>
            </div> */}
              </div>
            </CardContent>
          </Card>
          {Permission.hasPaymentHistoryPermissions(
            userPermissions,
            AppPermissions.PAYMENT_HISTORY.LIST,
            groupId
          ) && (
            <>
              <Typography className={`card-title`}>
                {t('PATIENTS.DRAWER.COPAY_DETAILS')}
              </Typography>
              <Card className="copay-card">
                <CardContent className="copay-card-content">
                  <MinGridTable
                    isLoading={isLoadingCopayBalances}
                    rows={patientCopayObject.copayList}
                    colDefs={copayColDefs}
                    noDataText={t('PATIENTS.DRAWER.NO_COPAY_BALANCES')}
                  />
                  <div className="copay-footer">
                    <div className="copay-amount-section-wrapper">
                      <div>{t('PATIENTS.DRAWER.TOTAL_COPAY_BALANCE')}</div>
                      <div>
                        <CurrencyFormatter
                          value={totalCopayBalanceAmount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={'$'}
                          ignoreRound={true}
                          useSign={true}
                        />
                      </div>
                    </div>
                    <div className="copay-button-wrapper">
                      <div
                        data-test-id="pcl-copayChargesComponent-editCopay"
                        key={'add-and-remove-copay'}
                        className="add-and-remove-btn-wrapper">
                        {Permission.hasPatientPermissions(
                          userPermissions,
                          AppPermissions.PATIENT.ADD_COPAY,
                          groupId
                        ) && (
                          <ButtonField
                            key={'add-copay'}
                            onClick={(): void => handleCopay()}
                            buttonText={t('PATIENTS.DRAWER.ADD_COPAY')}
                            className={classes.addCopayButton}
                          />
                        )}
                        {Permission.hasPatientPermissions(
                          userPermissions,
                          AppPermissions.PATIENT.REMOVE_COPAY,
                          groupId
                        ) &&
                          totalCopayBalanceAmount > 0 && (
                            <TertiaryButton
                              onClick={(): Promise<void> => handleCancelCopay()}
                              size="small"
                              className={classes.editButton}>
                              {t('PATIENTS.DRAWER.EDIT_COPAY')}
                            </TertiaryButton>
                          )}
                      </div>
                      <div>
                        {totalCopayBalanceAmount > 0 &&
                          Permission.hasPatientPermissions(
                            userPermissions,
                            AppPermissions.PATIENT.PAY,
                            groupId
                          ) && (
                            <Tooltip title={t('DUE_INVOICES.PAY').toString()}>
                              <TertiaryButton
                                onClick={(e: any): void => {
                                  openPayPopOver(patientDetail);
                                  e.stopPropagation();
                                }}
                                startIcon={<MoneyReceive />}>
                                {t('DUE_INVOICES.PAY')}
                              </TertiaryButton>
                            </Tooltip>
                          )}
                      </div>
                    </div>
                  </div>
                </CardContent>

                {/* Added additional things */}
                {cardPopUpOpen && renderCardPopUp()}
                {copayPopOver && (
                  <AdhocPaymentDashboard
                    open={copayPopOver}
                    onClose={res => {
                      handleCopay();
                      setForceUpdate(forceUpdate + 1);
                    }}
                    title={
                      <Trans
                        i18nKey={'AD_HOC.TITLE'}
                        values={{
                          guarantorName: HelperUtils.commaSeparatedFullName(
                            patient.guarantor_first_name,
                            patient.guarantor_last_name,
                            patient.guarantor_middle_name
                          )
                        }}
                        components={[<strong key={'X'} />]}
                      />
                    }
                    subtitle={t('AD_HOC.SUB_TITLE')}
                    guarantor={{
                      id: patient.guarantor_id,
                      first_name: patient.guarantor_first_name,
                      last_name: patient.guarantor_last_name,
                      middle_name: patient.guarantor_middle_name,
                      clinic_group_id: groupId,
                      clinic_id: acOfClinics[0] ?? clinicId,
                      email: patient.guarantor_email,
                      address_line_1: patient.guarantor_address_line_1,
                      zip_code: patient.guarantor_zip_code
                    }}
                    paymentMethod={PaymentTypes.PATIENT_COPAY_PAYMENT}
                    patientShared={patientShared}
                  />
                )}
                {patientCopayObject.cancel && (
                  <CopayCancelAlert
                    open={patientCopayObject.cancel}
                    title={t('PATIENTS.COPAY_OR_OTHER_CHARGE')}
                    subtitle={t('PATIENTS.COPAY_OR_OTHER_CHARGE_SUB_TITLE')}
                    list={patientCopayObject.copayList}
                    close={handleCopayCancelClose}
                    copayCancelList={patientCopayObject.copayCancelList}
                    handleSelectCopay={(item: any) => handleSelectCopay(item)}
                    cancelSelectedCopay={(): Promise<void> =>
                      cancelSelectedCopay()
                    }
                  />
                )}
              </Card>
            </>
          )}
        </>
      )}
      {openSettleCopayDialog && renderConfirmationForSettleTheCopay()}
      <Dialog
        open={postToEmrDialog.open}
        onClose={closePostToEmrDialog}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>{t('PATIENTS.POST_TO_EMR_DIALOG_TITLE')}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {t('PATIENTS.POST_TO_EMR_DIALOG_SUBTITLE')}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            label={t('PATIENTS.ACCOUNT_NUMBER')}
            value={postToEmrDialog.accountNumber}
            onChange={e =>
              setPostToEmrDialog(d => ({
                ...d,
                accountNumber: sanitizeEmrAlphanumericInput(e.target.value)
              }))
            }
            onKeyDown={e => {
              if (e.key === 'Enter' && !isPostingToEmr) {
                handleMarkPatientPostedToEmr();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closePostToEmrDialog} disabled={isPostingToEmr}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleMarkPatientPostedToEmr}
            disabled={isPostingToEmr}>
            {t('COMMON.SAVE')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={markUpdatedInEmrDialogOpen}
        onClose={closeMarkUpdatedInEmrDialog}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>
          {t('PATIENTS.MARK_UPDATED_IN_EMR_DIALOG_TITLE')}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {t('PATIENTS.MARK_UPDATED_IN_EMR_DIALOG_SUBTITLE')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeMarkUpdatedInEmrDialog}
            disabled={isMarkingUpdatedInEmr}>
            {t('COMMON.CANCEL')}
          </Button>
          <Button
            color="primary"
            variant="contained"
            style={markUpdatedInEmrDialogPrimaryButtonStyle}
            onClick={handleMarkPatientUpdatedInEmr}
            disabled={isMarkingUpdatedInEmr}>
            {t('PATIENTS.UPDATE_IN_EMR')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PatientDetailsCard;
